import { getToken } from ".";
import { HttpException } from "../../models/exceptions";
import { TemplateVariablesResponse } from "../../models/mail-template";
import store from "../../store";

// ### Fetching the resolved variables and datasets for a mail template
export async function fetchTemplateVariables({
  signal,
  templateKey,
}: {
  signal?: AbortSignal;
  templateKey: string;
}): Promise<TemplateVariablesResponse> {
  const companyId = store.getState().company.activeCompany?.id;
  if (!companyId) {
    throw new HttpException("No active company.");
  }

  const token = await getToken();

  const url = `${(window as any)._env_.REACT_APP_API_HOST}/companies/${companyId}/template-variables?template_key=${encodeURIComponent(
    templateKey
  )}`;

  const response = await fetch(url, {
    signal,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new HttpException("An error occurred while fetching the template variables.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  return await response.json();
}
